import { CommonsV1ApiBase } from './base';

type FliptKeysResponse = {
  enabled_flag_keys: string[];
  active_variant_keys: string[];
};

export const FliptKeysApis = {
  find(): Promise<FliptKeysResponse> {
    return CommonsV1ApiBase.appendPath('users/current/flipt_keys').get();
  },
};
